function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n\n    ", " + ", " {\n      margin-left: 6px;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import Text from "../../Typography/Text";
import colors from "../../../colors/index";
import { calcPrice, calcProductPrices } from "../helpers";
import { PriceSizes, PriceTypes } from "../theme";
import { PRICE_INTEGER_TEST_ID } from "../constants";
import { getTypographyFontSize } from "../../../theme/selectors";
import { mediaSmDown, mediaSmUp } from "../../../theme/helpers/media";
import Flex from "../../Grid/Flex";
/* Оставляем для карточки в списках */

/* legacy start */

var BasePrice = styled(Text).withConfig({
  displayName: "ProductPrice__BasePrice",
  componentId: "u2lzj5-0"
})(["", ""], function (_ref) {
  var price = _ref.theme.price,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? PriceTypes.main : _ref$type,
      sale = _ref.sale,
      _ref$priceSize = _ref.priceSize,
      priceSize = _ref$priceSize === void 0 ? PriceSizes.big : _ref$priceSize;
  return css(["color:", ";font-weight:", ";", ""], sale ? price.sale.color : price[type].color, price[type].fontWeight, getTypographyFontSize(price[type].size[priceSize].fontSize));
});
var StyledText = styled(Text).withConfig({
  displayName: "ProductPrice__StyledText",
  componentId: "u2lzj5-1"
})(["& s{text-decoration:line-through;text-decoration-color:", " !important;}"], colors.primaryMain);
var KomusBasePrice = styled(StyledText).withConfig({
  displayName: "ProductPrice__KomusBasePrice",
  componentId: "u2lzj5-2"
})(["", ""], function (_ref2) {
  var priceKomus = _ref2.theme.priceKomus,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? PriceTypes.main : _ref2$type,
      sale = _ref2.sale,
      _ref2$priceSize = _ref2.priceSize,
      priceSize = _ref2$priceSize === void 0 ? PriceSizes.big : _ref2$priceSize;
  return css(["color:", ";font-weight:", ";", ";text-decoration-color:", ";"], sale ? priceKomus.sale.color : priceKomus[type].color, priceKomus[type].fontWeight, getTypographyFontSize(priceKomus[type].size[priceSize].fontSize), priceKomus[type].textDecorationColor);
});
var PriceInt = styled(BasePrice).attrs({
  type: PriceTypes.main
}).withConfig({
  displayName: "ProductPrice__PriceInt",
  componentId: "u2lzj5-3"
})([""]);
var PriceIntKomus = styled(KomusBasePrice).attrs({
  type: PriceTypes.main
}).withConfig({
  displayName: "ProductPrice__PriceIntKomus",
  componentId: "u2lzj5-4"
})([""]);
var PriceEnd = styled(BasePrice).attrs({
  type: PriceTypes.end
}).withConfig({
  displayName: "ProductPrice__PriceEnd",
  componentId: "u2lzj5-5"
})([""]);
var PriceEndKomus = styled(KomusBasePrice).attrs({
  type: PriceTypes.end
}).withConfig({
  displayName: "ProductPrice__PriceEndKomus",
  componentId: "u2lzj5-6"
})([""]);
var PriceFract = styled(BasePrice).attrs({
  type: PriceTypes.fract
}).withConfig({
  displayName: "ProductPrice__PriceFract",
  componentId: "u2lzj5-7"
})([""]);
var PriceFractKomus = styled(KomusBasePrice).attrs({
  type: PriceTypes.fract
}).withConfig({
  displayName: "ProductPrice__PriceFractKomus",
  componentId: "u2lzj5-8"
})([""]);
export var OldListPrice = styled(BasePrice).attrs({
  type: PriceTypes.old
}).withConfig({
  displayName: "ProductPrice__OldListPrice",
  componentId: "u2lzj5-9"
})([""]);
export var KomusOldListPrice = styled(KomusBasePrice).attrs({
  type: PriceTypes.old
}).withConfig({
  displayName: "ProductPrice__KomusOldListPrice",
  componentId: "u2lzj5-10"
})([""]);
export var ListPrice = function ListPrice(_ref3) {
  var disabled = _ref3.disabled,
      price = _ref3.price,
      approximate = _ref3.approximate,
      sale = _ref3.sale,
      priceSize = _ref3.priceSize,
      isKomus = _ref3.isKomus;

  var _calcPrice = calcPrice(price, approximate),
      priceInt = _calcPrice.priceInt,
      priceFract = _calcPrice.priceFract;

  var _useContext = useContext(ThemeContext),
      priceSign = _useContext.priceSign;

  var disabledPrice = function disabledPrice() {
    return isKomus ? React.createElement(PriceEndKomus, {
      priceSize: disabled ? PriceSizes.medium : priceSize
    }, "\u0417\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0441\u044F") : React.createElement(PriceEnd, {
      priceSize: disabled ? PriceSizes.medium : priceSize
    }, "\u0417\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0441\u044F");
  };

  var notDisabledPrice = function notDisabledPrice() {
    return isKomus ? React.createElement(React.Fragment, null, React.createElement(PriceIntKomus, {
      "data-testid": PRICE_INTEGER_TEST_ID,
      sale: sale,
      priceSize: priceSize
    }, priceInt), React.createElement(PriceFractKomus, {
      sale: sale,
      priceSize: priceSize
    }, ",", priceFract, " ", priceSign)) : React.createElement(React.Fragment, null, React.createElement(PriceInt, {
      "data-testid": PRICE_INTEGER_TEST_ID,
      sale: sale,
      priceSize: priceSize
    }, priceInt), React.createElement(PriceFract, {
      sale: sale,
      priceSize: priceSize
    }, ",", priceFract, " ", priceSign));
  };

  var resultDisabled = disabledPrice();
  var resultNotDisabled = notDisabledPrice();
  return disabled ? resultDisabled : resultNotDisabled;
};
/* legacy end */

export var PriceText = styled(Text).attrs(function (_ref4) {
  var type = _ref4.type,
      children = _ref4.children;
  return {
    children: type === PriceTypes.old ? React.createElement("s", null, children) : children
  };
}).withConfig({
  displayName: "ProductPrice__PriceText",
  componentId: "u2lzj5-11"
})(["", ""], function (_ref5) {
  var price = _ref5.theme.price,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? PriceTypes.main : _ref5$type,
      sale = _ref5.sale;
  return css(["color:", ";font-weight:", ";", ""], sale ? price.sale.color : price[type].color, price[type].fontWeight, getTypographyFontSize(price[type].size[PriceSizes.big].fontSize));
});
export var Price = function Price(_ref6) {
  var price = _ref6.price,
      type = _ref6.type,
      sale = _ref6.sale,
      className = _ref6.className;

  var _calcPrice2 = calcPrice(price),
      priceInt = _calcPrice2.priceInt;

  var _useContext2 = useContext(ThemeContext),
      priceSign = _useContext2.priceSign;

  return React.createElement(PriceText, {
    type: type,
    sale: sale,
    className: className
  }, priceInt, "\xA0", priceSign);
};
var StyledPrice = styled(Price).withConfig({
  displayName: "ProductPrice__StyledPrice",
  componentId: "u2lzj5-12"
})(["", " ", ""], mediaSmUp(_templateObject(), function (_ref7) {
  var $isProductInCart = _ref7.$isProductInCart,
      type = _ref7.type,
      isKomus = _ref7.isKomus;

  if ($isProductInCart) {
    return css(["font-size:12px;line-height:12px;"]);
  }

  if (isKomus) {
    switch (type) {
      case PriceTypes.old:
        return css(["font-size:14px !important;color:", " !important;text-decoration:line-through !important;text-decoration-color:", " !important;line-height:16px !important;s{position:relative;text-decoration:line-through !important;text-decoration-color:", " !important;}"], colors.dark100, colors.primaryAction, colors.primaryAction);

      case PriceTypes.main:
        return css(["font-size:22px !important;color:", " !important;line-height:24px !important;font-weight:500 !important;"], colors.dark300);

      default:
        break;
    }
  }

  switch (type) {
    case PriceTypes.old:
      return css(["font-size:12px !important;line-height:14px;s{position:relative;text-decoration:none;}s:after{position:absolute;content:'';left:0;top:50%;right:0;border-top:1px solid;border-color:inherit;transform:rotate(-7deg);}"]);

    case PriceTypes.main:
      return css(["font-size:18px !important;line-height:20px;"]);

    default:
      break;
  }
}), mediaSmDown(_templateObject2(), function (_ref8) {
  var $isProductInCart = _ref8.$isProductInCart,
      type = _ref8.type,
      isKomus = _ref8.isKomus;

  if ($isProductInCart) {
    return css(["font-size:12px;line-height:12px;"]);
  }

  if (isKomus) {
    switch (type) {
      case PriceTypes.old:
        return css(["font-size:12px !important;color:", " !important;text-decoration:line-through !important;text-decoration-color:", " !important;line-height:14px !important;s{position:relative;text-decoration:line-through !important;text-decoration-color:", " !important;}"], colors.dark100, colors.primaryAction, colors.primaryAction);

      case PriceTypes.main:
        return css(["font-size:16px !important;color:", " !important;line-height:20px !important;"], colors.dark300);

      default:
        break;
    }
  }

  switch (type) {
    case PriceTypes.old:
      return css(["font-size:12px !important;line-height:14px;s{position:relative;text-decoration:none;}s:after{position:absolute;content:'';left:0;top:50%;right:0;border-top:1px solid;border-color:inherit;transform:rotate(-7deg);}"]);

    case PriceTypes.main:
      return css(["font-size:16px !important;line-height:20px;"]);

    default:
      break;
  }
}));
var ProductPriceContainer = styled(Flex).attrs(function (_ref9) {
  var _ref9$$isProductInCar = _ref9.$isProductInCart,
      $isProductInCart = _ref9$$isProductInCar === void 0 ? false : _ref9$$isProductInCar;
  return {
    column: !$isProductInCart
  };
}).withConfig({
  displayName: "ProductPrice__ProductPriceContainer",
  componentId: "u2lzj5-13"
})(["", " + ", "{margin-left:", ";}", ""], StyledPrice, StyledPrice, function (_ref10) {
  var $isProductInCart = _ref10.$isProductInCart;
  return $isProductInCart && '4px';
}, mediaSmUp(_templateObject3(), StyledPrice, StyledPrice));
export var ProductPrice = function ProductPrice(_ref11) {
  var product = _ref11.product,
      _ref11$isProductInCar = _ref11.isProductInCart,
      isProductInCart = _ref11$isProductInCar === void 0 ? false : _ref11$isProductInCar,
      _ref11$isKomus = _ref11.isKomus,
      isKomus = _ref11$isKomus === void 0 ? false : _ref11$isKomus;
  var isOnSale = product.sale || Boolean(product.old_price);

  var _calcProductPrices = calcProductPrices(product),
      currentPrice = _calcProductPrices.currentPrice,
      oldPrice = _calcProductPrices.oldPrice;

  return React.createElement(ProductPriceContainer, {
    $isProductInCart: isProductInCart
  }, React.createElement(StyledPrice, {
    price: currentPrice,
    sale: isOnSale,
    type: PriceTypes.main,
    $isProductInCart: isProductInCart,
    isKomus: isKomus
  }), oldPrice && React.createElement(StyledPrice, {
    price: oldPrice,
    type: PriceTypes.old,
    $isProductInCart: isProductInCart,
    isKomus: isKomus
  }));
};
export default ProductPrice;